<template>
  <div v-if="region_code != 'CN'" style="width:30px; text-align:center; padding:2px; border-radius:4px; background: linear-gradient(120.86deg, rgb(63 9 157) 0%, rgb(105 39 219) 100%); color: #FFF;">
    {{ region_code }} 
  </div>
  <div v-else >
    {{ region_code }} 
  </div>
</template>
<script>
  import { defineComponent } from 'vue'

  export default defineComponent({
    props: ['region_code'],
    data(){
      return {  }
    },
    // mounted() {},
    methods:{ },
  })
</script>